import React, { Component } from "react";
import { withRouter } from "react-router-dom";


class TopicList extends Component {
    render() {
        return (
            <div className="search-suggetion-list topics-suggetion">
                <div className="search-suggetion-block">
                    {this.props.searchObjectResults.map((item, index) => {
                        return (
                            <div className="search-suggetion-item" key={index}>
                                <div
                                    className="search-suggetion-info"
                                    onClick={event => {
                                        this.props.redirectionFn(
                                            event,
                                            item.id,
                                            this.props,
                                            this.props.showLoader,
                                            this.props.hideLoader,
                                            this.props.currentLanguage
                                        )
                                    }}
                                >
                                    <h4>{item.name}</h4>
                                </div>
                                <div className="search-suggetion-follow">
                                    <span className={!item.isFollowing ? "suggetion-follow" : "suggetion-follow hide"} onClick={() => { this.props.followObject(item.id, this.props.objectType) }} >Follow</span>
                                    <span className={item.isFollowing ? "suggetion-unfollow" : "suggetion-unfollow hide"}>Following</span>
                                </div>
                            </div>
                        );
                    })
                    }
                </div>
            </div>
        );
    }
}

export default withRouter(TopicList);